import React from "react";
import { Props } from "./types";

function AddColumnBeforeIcon({ className }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="16"
      height="16"
    >
      <rect x="9" y="3" width="12" height="18" rx="1" />
      <line x1="9" y1="9" x2="21" y2="9" />
      <line x1="9" y1="15" x2="21" y2="15" />
      <line x1="15" y1="9" x2="15" y2="21" />
      <line x1="4" y1="3" x2="4" y2="9" />
      <line x1="1" y1="6" x2="7" y2="6" />
    </svg>
  );
}

export { AddColumnBeforeIcon };
